import { IpDialog } from '@blofin/blofin-component';
import { NavFooter, NavHeader } from '@blofin/blofin-nav';
import { BUITheme, NoticeProvider, ThemeProvider } from '@blofin/blofin-ui';
import useChangeTheme from 'hooks/useChangeTheme';
import { useRouter } from 'next/router';
import { type FC, type ReactNode } from 'react';
import apiConfig from 'services/http/base';

const PageLayout: FC<{
  children: ReactNode;
  theme?: BUITheme;
  headerTheme?: BUITheme;
  showTheme?: boolean;
  mainClass?: string;
  hideHeader?: boolean;
  hideFooter?: boolean;
}> = ({
  children,
  theme: initTheme = 'light',
  headerTheme: headerThemeProp,
  showTheme = true,
  mainClass,
  hideHeader,
  hideFooter,
}) => {
  const { locale } = useRouter();
  const { changeTheme, theme } = useChangeTheme(true, initTheme);

  const realHeaderTheme = headerThemeProp || (showTheme ? theme : 'light');
  const direction = locale === 'ar' ? 'rtl' : 'ltr';

  return (
    <ThemeProvider value={{ theme, direction }}>
      <NoticeProvider>
        {!hideHeader && (
          <NavHeader
            apiConfig={apiConfig}
            locale={locale}
            showTheme={showTheme}
            themeLock={true}
            theme={realHeaderTheme}
            pageTheme={headerThemeProp ? theme : undefined}
            switchTheme={changeTheme}
          />
        )}
        <main className={mainClass || 'min-h-[calc(100vh-200px)] bg-light-background dark:bg-base-fill-primary'}>
          {children}
        </main>
        <IpDialog theme={theme} />
        {!hideFooter && <NavFooter apiConfig={apiConfig} theme={showTheme ? theme : 'light'} />}
      </NoticeProvider>
    </ThemeProvider>
  );
};

export default PageLayout;
